import {
  CompaniesInfiniteSelectField,
  FloatingFormItem,
} from '@/components/_common';
import { GenerateRemittanceByWriteOffRequest } from '@/core/domain/financial/Boletos/Boletos.types';
import { useDefaultEmptyFieldError } from '@/hooks';
import { Col, Form, Input, Modal, ModalProps, Row } from 'antd';
import { useEffect } from 'react';

interface WriteOffGenerateRemmitanceFormValues {
  writeOffProtocol: string;
  companyId: number;
}

type Props = Omit<ModalProps, 'onCancel'> & {
  onCancel: () => void;
  companyId?: number;
  onCallback: (values: GenerateRemittanceByWriteOffRequest) => void;
  loading?: boolean;
};

export default function WriteOffGenerateRemmitanceModal({
  open,
  onCancel,
  companyId,
  onCallback,
  loading,
}: Props) {
  const defaultEmptyFieldError = useDefaultEmptyFieldError();

  const [form] = Form.useForm<WriteOffGenerateRemmitanceFormValues>();

  const handleOk = async () => {
    const values = await form.validateFields();

    await onCallback({ ...values });

    form.resetFields();

    onCancel();
  };

  useEffect(() => {
    if (companyId) {
      form.setFieldValue('companyId', companyId);
    }
  }, [open]);

  return (
    <Modal
      width={400}
      open={open}
      onOk={handleOk}
      onCancel={onCancel}
      title="Leitura de arquivo de retorno"
      cancelText="Cancelar"
      okText="Enviar"
      okButtonProps={{ loading }}
    >
      <Form form={form}>
        <Row gutter={[24, 24]}>
          <Col span={24}>
            <FloatingFormItem
              label="Protocolo de baixa"
              name="writeOffProtocol"
              rules={[defaultEmptyFieldError]}
            >
              <Input />
            </FloatingFormItem>
          </Col>

          <Col span={24}>
            <FloatingFormItem label="Empresa" name="companyId">
              <CompaniesInfiniteSelectField disabled />
            </FloatingFormItem>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
